const usd = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })

export function money(value) {
	const number = Number(value)
	return Number.isFinite(number) ? usd.format(number) : ''
}

export function shortDate(value) {
	if (!value) return ''
	const date = new Date(value)
	if (Number.isNaN(date.getTime())) return ''
	return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
}

export function plural(count, word, many = `${word}s`) {
	return `${count} ${count === 1 ? word : many}`
}
